import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';

const styles = {
  wrapper: {
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    py: 6,
  },
  content: {
    textAlign: 'center',
    maxWidth: 480,
    mx: 'auto',
  },
  icon: {
    fontSize: 72,
    color: '#ef4444',
    mb: 2,
  },
  title: {
    fontWeight: 700,
    mb: 1,
  },
  message: {
    color: 'text.secondary',
    mb: 4,
    lineHeight: 1.6,
  },
  actions: {
    display: 'flex',
    gap: 2,
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
};

const ErrorState = ({ error, onRetry, title = 'Something went wrong' }) => {
  const navigate = useNavigate();

  const displayMessage = error || 'An unexpected error occurred. Please try again later.';

  return (
    <Container maxWidth="lg">
      <Box sx={styles.wrapper}>
        <Box sx={styles.content}>
          <ErrorOutlineOutlinedIcon sx={styles.icon} />
          <Typography variant="h5" sx={styles.title}>{title}</Typography>
          <Typography variant="body1" sx={styles.message}>{displayMessage}</Typography>
          <Box sx={styles.actions}>
            {onRetry && (
              <Button variant="contained" startIcon={<RefreshIcon />} onClick={onRetry} sx={{ bgcolor: '#008578', '&:hover': { bgcolor: '#006b5f' } }}>
                Try Again
              </Button>
            )}
            <Button variant="outlined" startIcon={<HomeIcon />} onClick={() => navigate('/')} sx={{ borderColor: '#008578', color: '#008578', '&:hover': { borderColor: '#006b5f', bgcolor: 'rgba(0,133,120,0.04)' } }}>
              Back to Events
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default ErrorState;
